import moment from 'moment';
import React from 'react';
import { useQuery } from 'react-query';

import { assetBalanceHistoryApi, shopsApi, usersApi } from 'api';
import { BalanceHistory } from 'components';
import { QueryKey } from 'enums';
import {
  usePartialQuery,
  useQueryFilters,
  useShopsQuery,
  useUser,
  useUserContext,
} from 'hooks';
import { AssetBalanceHistoryFilters } from 'types';
import { assetBalanceHistoryUtils } from 'utils';

export const TechOperatorAssetBalanceHistoryPage: React.FC = () => {
  useQueryFilters<AssetBalanceHistoryFilters>({
    from: moment().subtract(1, 'w').startOf('d').toISOString(),
  });

  const { role } = useUser();

  const { p2pProviders } = useUserContext();
  const { data: users = [] } = useQuery(
    QueryKey.Users,
    usersApi.getAllWithPlatform,
  );
  const { data: shops = [] } = useShopsQuery(
    QueryKey.Shops,
    shopsApi.getAllAsRole(role),
  );

  const queryResult = usePartialQuery(
    QueryKey.AssetBalanceHistory,
    assetBalanceHistoryApi.getAllPaginated,
  );

  return (
    <BalanceHistory
      queryResult={queryResult}
      additionalColumns={assetBalanceHistoryUtils.getTechOperatorColumns()}
      additionalFilters={[
        ...assetBalanceHistoryUtils.getTechOperatorFilters(users, p2pProviders),
        ...assetBalanceHistoryUtils.getShopFilters(shops),
      ]}
    />
  );
};
